export const columns = function() {
  return [
    {
      prop: 'tyName',
      label: '特约名称',
    },
    {
      prop: 'tyContent',
      label: '特约内容',
    },
    {
      prop: 'handle',
      label: '操作',
      width: 150
    }
  ]
} 

export default {}